<template>
  <v-card>
    <v-form ref="form" v-model="valid" @submit.prevent>
      <v-row>
        <v-col cols="auto">
          <v-card-title>
            What are the strategic anchors that guide all decisions your company
            makes?
          </v-card-title>
          <v-card-subtitle>
            Add strategic anchors that answer the question above. We use this in
            your survey as helper text.
          </v-card-subtitle>
        </v-col>
        <v-spacer></v-spacer>
        <v-col sm="auto" class="my-auto mr-sm-6 text-center"> </v-col>
      </v-row>
      <v-card-text class="pt-0">
        <v-row v-for="(sa, i) in strategic_anchors" :key="i">
          <v-col cols="12">
            <v-text-field
              v-model="sa.name"
              :label="`Strategic Anchor ${i + 1}`"
              outlined
              maxlength="250"
              :rules="[$rules.required]"
              required
              hide-details
              :disabled="!is_admin"
            >
              <template v-slot:append-outer>
                <v-btn
                  icon
                  @click="removeAnchor(i)"
                  tabindex="-1"
                  v-if="is_admin"
                >
                  <v-icon>cancel</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-btn
              outlined
              x-large
              color="secondarytext"
              class="border--question border--dashed"
              block
              @click="addAnchor"
              v-if="is_admin"
            >
              <v-icon color="secondarytext" class="mr-2">add_box</v-icon>
              Add a Strategic Anchor
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-if="is_admin">
        <v-btn @click="save" :loading="saving">Update</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "StrategicAnchorForm",
  components: {},
  data: () => ({
    valid: true,
    saving: false
  }),
  watch: {},
  computed: {
    ...mapGetters({
      strategic_anchors: "company/strategic_anchors",
      is_admin: "profile/is_admin"
    })
  },
  created() {},
  methods: {
    addAnchor() {
      this.strategic_anchors.push({ value: "" });
    },
    removeAnchor(index) {
      this.strategic_anchors.splice(index, 1);
    },
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch("company/saveStrategicAnchors", this.strategic_anchors)
          .then(() => {
            this.$emit("save");
            this.$root.$snackbarSuccess(`Strategic Anchors saved.`);
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occured while saving"
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-input__append-outer {
  margin-top: auto;
  margin-bottom: auto;
}
</style>
